import { UseMutationResult, UseQueryResult, useMutation, useQuery } from '@tanstack/react-query';
import { AxiosError, AxiosResponse } from 'axios';
import {
  getActivities,
  getReport,
  getReportForm,
  getUserstories,
  searchUserstories,
  updateUserstories,
} from 'src/requests/userstory';
import { UserStory } from 'src/types/epic';
import { reportUserResponse } from 'src/types/report';

export const useGetUserstories = (): UseQueryResult<UserStory[], AxiosError> =>
  useQuery(['getUserstories'], getUserstories);

export const useUpdateUserstories = () => useMutation(updateUserstories);

export const useSearchUserstories = () => useMutation(searchUserstories);

export const useUserstoryActivities = () => useMutation(getActivities);

export const useGetReportForm = (): UseQueryResult<any, AxiosError> => useQuery(['getReportForm'], getReportForm);
export const useGetReport = (): UseMutationResult<
  AxiosResponse<reportUserResponse>,
  any,
  { url: string; param: string },
  unknown
> => useMutation(getReport);
